import React, { useState } from 'react'
import styles from '../styles.module.scss'

const Index = ({row, setRow, lastRow, addRow, deleteRow}) => {
    const [data,
        setData] = useState(row);

    const handleHeadChange = (e) => {
        const {name, value} = e.target
        setData({
            ...data,
            [name]: value
        })
    }

    const handleBlur = () => {
        setRow(data)
    }
    return (
        <div>
            <div className={styles.headTitle}>{data.title}</div>
            <div className={styles.headItem}>
                <input
                    className={styles.headInput}
                    type='text'
                    name='name'
                    onChange={handleHeadChange}
                    placeholder='ФИО'
                    value={data.name}
                    onBlur={handleBlur}/>
                <input
                    className={styles.headInput}
                    type='text'
                    name='rank'
                    onChange={handleHeadChange}
                    placeholder='Воинское звание'
                    onBlur={handleBlur}
                    value={data.rank}/>
                <input
                    className={styles.headInput}
                    type='text'
                    name='post'
                    onChange={handleHeadChange}
                    placeholder='Должность'
                    onBlur={handleBlur}
                    value={data.post}/> 
                <input
                    className={styles.headInput}
                    type='date'
                    name='date'
                    onChange={handleHeadChange}
                    placeholder='Дата'
                    onBlur={handleBlur}
                    value={data.date}/> 
                {/* <div
                className={styles.headIcon}
                onClick={lastRow ? addRow : deleteRow}>
                {lastRow ? <MdAdd title='Добавить'/> : <MdDelete title='Удалить'/>}
                </div> */}
            </div>
        </div>
    )
}

export default Index